import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import { route } from '@helpers'
import { colors } from '@styles/vars'
import React from 'react'
import { Link } from 'react-router-dom'
import ParticipatingSalon from '../../Participating/components/ParticipatingSalon'

export default function EntriesSection({ salons }: Props) {
    if (!salons?.length)
        return null

    return (
        <Grid gap="10px">
            <Grid gap="0px">
                <small><Link to={route("customer:participating")} style={{ textDecoration: "none", color: colors.darkGrey }}>Entries</Link></small>
                <hr />
            </Grid>
            <Grid gap="15px">
                <Grid>
                    {salons.slice(0, 2).map(salon => <ParticipatingSalon key={salon.id} data={salon} />)}
                </Grid>
                {salons.length > 2 && <Flex justifyContent="flex-end"><Button type="tertiary" to={route("customer:participating")}>See more</Button></Flex>}
            </Grid>
        </Grid>
    )
}

interface Props {
    salons?: Interfaces.Salon[]
}